import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import classnames from "classnames";

import { TooltipType } from "@/components/General/Tooltip/tooltip.types";
import { OrderDetailsModel } from "@/redux/modules/api/data/orderDetail/@types/orderDetails.model";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { BreakpointProvider } from "@/utils/breakpoints/breakpoints.provider";

import PriceSummary from "../shared/PriceSummary/priceSummary.component";
import { ProductCollectionBlock } from "../shared/ProductCollectionBlock/productCollectionBlock.container";
import { DeliveryPromiseComponent } from "./DeliveryPromise/deliveryPromise.component";
import Details from "./Details/details.component";

type Props = {
    orderDetails: OrderDetailsModel;
    additionalServiceTooltip?: TooltipType;
};

const OrderDetailComponent = ({
    orderDetails,
    additionalServiceTooltip
}: Props) => {
    const { t } = useGranite();

    const deliveryProducts = orderDetails.items.filter(
        (i) =>
            i.deliveryType === DeliveryType.HomeDelivery &&
            !i.isAdditionalService
    );
    const collectProducts = orderDetails.items.filter(
        (i) =>
            i.deliveryType === DeliveryType.ClickAndCollect &&
            !i.isAdditionalService
    );

    return (
        <BreakpointProvider>
            <h5 className={classnames("font-weight-bold")}>
                {t("orderOverview.title.orderId")}
                {orderDetails.orderId}
            </h5>
            <ProductCollectionBlock
                deliveryProducts={deliveryProducts}
                collectProducts={collectProducts}
                additionalServiceTooltip={additionalServiceTooltip}
                productTitleLink={true}
                DeliveryPromiseComponent={DeliveryPromiseComponent}
            />
            <PriceSummary orderDetails={orderDetails} />
            <Details orderDetails={orderDetails} />
        </BreakpointProvider>
    );
};

export { OrderDetailComponent };
